var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 8)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#000",
    strokeWidth: 1.25,
    cx: 176,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5.5l23 11m-29 84l-3.79 10.377M27.037 131.4l5.898 2.203-3.46 5.947 6.072 2.392-3.933 5.758m128.733 35.37l.693-9.316 10.292.052.416-9.222 9.274.332M.5 48.5s6.131 6.413 6.847 14.805c.715 8.393-2.52 14.806-2.52 14.806M124.555 90s-7.444 0-13.67 6.192c-6.227 6.192-4.838 12.012-4.838 12.012m2.24 68.626s-4.026-9.025-18.145-9.025-18.145 5.7-18.145 5.7",
    stroke: "#000",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.716 36.146l5.243-9.521h11.093l5.416 9.521-5.41 9.185H90.953l-5.237-9.185zm63.909 15.479h10.75v10.75h-10.75z",
    stroke: "#000",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 71.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 170.5,
    cy: 95.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 81.5,
    cy: 134.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 13.5,
    cy: 23.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93 71h3v3h-3zm33 84h3v3h-3zm-85 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.384 51.122l5.758-4.454 6.453 4.205-2.294 7.363h-7.79l-2.127-7.114zM130.195 4.03l13.83 5.062-10.09 7.048-3.74-12.11zm-83 95l14.83 5.429-10.82 7.557-4.01-12.987zM5.213 161.495l11.328 20.897L2.265 180l2.948-18.505z",
    stroke: "#000",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05 127.468s-.51 2.183.995 3.366c1.56 1.226 8.642-1.895 3.967-7.785-2.367-2.477-6.5-3.226-9.33 0-5.208 5.936 0 17.51 11.61 13.73 12.458-6.257 5.633-21.656-5.073-22.654-6.602-.606-14.043 1.756-16.157 10.268-1.718 6.92 1.584 17.387 12.45 20.476 10.866 3.09 19.331-4.31 19.331-4.31",
    stroke: "#000",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbg);
export default __webpack_public_path__ + "static/media/chatbg.ce90198dcc76948311ca9b03f05ff0f6.svg";
export { ForwardRef as ReactComponent };